import SinchMessaging from '../../pages/sinch/messaging/SinchMessaging.vue';
import {authGuard} from '../guards';

function getRoutes(routePrefix, layout) {
  const basePath = routePrefix === 'library'
    ? '/v2/app/content'
    : '/v2/mobile';

  return [
    {
      path: `${basePath}/messaging`,
      name: `${routePrefix}.messaging.index`,
      component: SinchMessaging,
      meta: {
        layout: layout,
        title: 'Text Messaging',
      },
    },
  ]
}

export default [
  ...authGuard([
    ...getRoutes('library', 'content'),
    ...getRoutes('mobile', 'mobile'),
  ]),
]
